import { Component, For } from "solid-js";
import { ListItem } from "../types";

export type CheckboxesProps = {
    values: () => string[];
    onInput: (value: string) => void;
    list: ListItem[];
    name: string;
}
export const Checkboxes : Component<CheckboxesProps> = (props) => {
    return (
        <div style="padding-left: 20px;">
            <For each={props.list}>{(item) => 
                <div class="checkbox">
                    <label>
                        <input type="checkbox"
                            name={props.name}
                            checked={(props.values()||[]).some(x => x == item.Value)}
                            onInput={() => props.onInput(item.Value)}
                        /> <i></i> {item.Text}
                    </label>
                </div>
            }</For>
        </div>
    )
}

export type CheckboxValuesProps = {
    values: () => string[];
    onInput: (value: string) => void;
    list: ListItem[];
    name: string;
}
export const CheckboxValues : Component<CheckboxValuesProps> = (props) => {
    return (
        <div style="padding-left: 20px;">
            <For each={props.list}>{(item) => 
                <div class="checkbox">
                    <label>
                        <input type="checkbox"
                            name={props.name}
                            checked={(props.values()||[]).some(x => x == item.Value)}
                            onInput={() => props.onInput(item.Value)}
                        /> <i></i> {item.Text}
                    </label>
                </div>
            }</For>
        </div>
    )
}